<template>
  <div>
    <div>
      <h1>Thanks for the cash!!</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CheckoutSuccess',
  props: [],
  methods: {
  },
  data() {
    return {
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/schools/CheckoutSuccess.vue